import React from 'react'
import { isEmpty } from 'ramda'
import CurrentParams from '../../../../../../modules/CurrentParams'
import Activities from '../../../../../../modules/Activities'
import { StyledParams } from './styled'
import Diary from '../../../../../../modules/Diary'

const Params = ({ rowid, params }) => {
    return (
        <StyledParams>
            {
                !isEmpty(params) &&
                <>
                    {
                        params.current &&
                        <CurrentParams
                            current={params.current}
                        />
                    }
                    {
                        params.details && params.calendar &&
                        <Activities
                            activities={params.details}
                            calendar={params.calendar}
                        />
                    }
                    {
                        params.diary &&
                        <Diary
                            id={rowid}
                            endpointDiary='/rpc/get_obj_alerts'
                            endpointNote=''
                            diary={params.diary}
                            disableAddNote
                        />
                    }
                </>
            }
        </StyledParams>
    )
}

export default Params